import React, { useEffect, useMemo, useState,useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";

import {
  getSchoolListApiCall,
  editSchoolDataApiCall,
  grantSchoolSubscriptionApiCall,
} from "../../Store/slices/SchoolSlice";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
  TOAST_ERROR,
} from "../../utils/common.service";

export default function ManageSchool() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [isActive, setIsActive] = useState("Inactive");
  // Manual-subscription grant modal
  const [grantSchool, setGrantSchool] = useState(null);
  const [grantForm, setGrantForm] = useState({
    max_student: 30,
    validity_days: 365,
    status: "Active",
  });
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const openGrantModal = (school) => {
    setGrantForm({
      max_student: school?.max_student || 30,
      validity_days: 365,
      status: "Active",
    });
    setGrantSchool(school);
  };

  const handleGrantSubmit = async () => {
    if (!grantSchool) return;
    const seats = Number(grantForm.max_student);
    const days = Number(grantForm.validity_days);
    if (!Number.isInteger(seats) || seats < 1 || !Number.isInteger(days) || days < 1) {
      TOAST_ERROR("Seats and validity days must be whole numbers of 1 or more");
      return;
    }
    dispatch(setLoader(true));
    try {
      const { code, message } = await dispatch(
        grantSchoolSubscriptionApiCall({
          school_id: grantSchool.id,
          max_student: seats,
          validity_days: days,
          status: grantForm.status,
        })
      ).unwrap();
      if (code !== "1") {
        TOAST_ERROR(message || "Granting the subscription failed");
        return;
      }
      setGrantSchool(null);
      handleSchoolListAPI();
      SWIT_DELETE_SUCCESS(
        grantForm.status === "Cancelled"
          ? "Subscription revoked"
          : `Granted ${seats} seats for ${days} days`
      );
    } catch (error) {
      console.error("Error granting subscription:", error);
      TOAST_ERROR("Granting the subscription failed — please try again");
    } finally {
      dispatch(setLoader(false));
    }
  };


  let userData = Cookies.get("dataCA")
  ? JSON.parse(Cookies.get("dataCA"))
  : null;
const role = userData ? userData.role : null;
const { permissions } = useContext(PermissionContext);

  const handleSortChange = (fieldName, sort) => {
    setFieldSort(`${fieldName} ${sort}`);
    setSortColumn(fieldName);
    setAscSort(sort === "asc");
  };

  const {
    SchoolList: { data: SchoolList },
  } = useSelector((state) => state.school);
  //console.log('SchoolList :', SchoolList);

  useEffect(() => {
    handleSchoolListAPI();
  }, [page, debounce, fieldSort]);

  const handleSchoolListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    dispatch(getSchoolListApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    // console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      await dispatch(editSchoolDataApiCall(submitData));
      dispatch(getSchoolListApiCall({
        search: debounce,
        page: page,
        fieldSort: fieldSort,
      }));

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };
        try {
          await dispatch(editSchoolDataApiCall(submitData));
          await SWIT_DELETE_SUCCESS(`School deleted successfully`);

          // Refresh the School list after deletion
          handleSchoolListAPI();
        } catch (error) {
          console.error("Error deleting School:", error);
        } finally {
          dispatch(setLoader(false));
        }
      }
    });
  };

  const companyListData = useMemo(() => {
    // console.log("SchoolList :", SchoolList);
    return SchoolList?.map((item, index) => (
      <tr key={index}>
        <td>{item?.id}</td>
        <td>{item?.name}</td>
        <td>{item?.email}</td>
        <td>{item?.phone ? item.phone : "N/A"}</td>
        {role == "admin" ||
          (permissions[4]?.module_id === 5 &&
            permissions[4]?.permission_update === 1) ? (
            <td>
              <div className="form-check form-switch ">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
            </td>
          ) : (
            <td>{item?.status}</td>
          )}
        <td>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() =>
              navigate(`/manage_school/view_school_details`, {
                state: { schoolData: item },
              })
            }
          >
            <i className="ri-eye-line"></i>
          </a>

          {role == "admin" ||
          (permissions[4]?.module_id === 5 &&
            permissions[4]?.permission_update === 1) ? (
            <a
              className="text-reset fs-18 cursor_pointer ms-1"
              title="Grant / edit subscription"
              onClick={() => openGrantModal(item)}
            >
              <i className="ri-bank-card-line"></i>
            </a>
          ) : null}

          {role == "admin" ||
          (permissions[4]?.module_id === 5 &&
            permissions[4]?.permission_delete === 1) ? (
              <a
              className="text-reset fs-18 cursor_pointer"
              onClick={() => handleDeleteManage(item?.id)}
            >
              <i className="ri-delete-bin-6-line"></i>
            </a>
          ) : (
            null
          )}

         
        </td>
      </tr>
    ));
  }, [SchoolList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage School`} header={`School`} />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`client`}
                  setSearch={setSearch}
                  isExport={false}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(SchoolList)?.length > 0 ? (
                      <>
                        <table className="table table-centered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                ID
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "name"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "name",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Name
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "email"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "email",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Email
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "phone_no"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "phone_no",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Phone
                              </th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("School")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={SchoolList[0]?.school_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`School`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {grantSchool && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Subscription — {grantSchool.name}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setGrantSchool(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Maximum students (seats)</label>
                    <input
                      type="number"
                      min="1"
                      className="form-control"
                      value={grantForm.max_student}
                      onChange={(e) =>
                        setGrantForm({ ...grantForm, max_student: e.target.value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Validity (days)</label>
                    <input
                      type="number"
                      min="1"
                      className="form-control"
                      value={grantForm.validity_days}
                      onChange={(e) =>
                        setGrantForm({
                          ...grantForm,
                          validity_days: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-1">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      value={grantForm.status}
                      onChange={(e) =>
                        setGrantForm({ ...grantForm, status: e.target.value })
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Cancelled">Cancelled (revoke)</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setGrantSchool(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleGrantSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}
